<template>
    <video id="player" class="video-js" :style="{width: '100%', height: '100%'}">
        <source :src="data" type="video/mp4">
    </video>
</template>

<style type="text/css">
    .vjs-big-play-button{
        font-size: 5em !important;
        left: 50% !important;
        top: 50% !important;
        width: 80px !important;
        height: 80px !important;
        border-width: 1px !important;
        border-radius: 50% !important;
        transform: translate(-50%, -50%) !important;
    }
</style>

<script type="text/javascript">
    export default {
        data () {
            return {
                Player: null,
            }
        },
        props: ['data'],
        mounted() {
            console.log('this.video.url---------->', this.data);
            this.readyPlayer();
        },
        methods: {
            readyPlayer() {
                //初始化视频
                this.Player = this.$video('#player', {
                    controls: false, // 启用控件
                    autoplay: true, // 自动播放
                    muted: true, // 静音播放
                    loop: true, // 循环播放
                    preload: 'auto', // 是否应在<video>挂载后立即下载视频
                });
            },
            __dispose(){
                this.Player.dispose();
            }
        },
        beforeDestroy() {
            this.__dispose();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Player.vue